<div class="feedback-panel" [class.is-open]="open">
    <div class="panel-inner" *ngIf="open">
        <div class="panel-question">What was wrong with this answer?</div>

        <div class="chip-row">
            <button
                *ngFor="let chip of chips; trackBy: trackByChipId"
                type="button"
                class="chip-button"
                (click)="onChipClick(chip.id)">
                <app-simple-badge
                    [label]="chip.label"
                    color="outline"
                    [active]="selectedChip === chip.id">
                </app-simple-badge>
            </button>
        </div>

        <!-- Teach CTA — lesson-worthy chip + super user. -->
        <div class="follow-up teach-cta" *ngIf="showTeachCta">
            <p class="follow-up-lead">
                You can teach Gable the right answer so it doesn't make this mistake again.
            </p>
            <div class="follow-up-actions follow-up-actions-right">
                <button
                    mat-flat-button
                    type="button"
                    color="accent"
                    class="ghost-btn"
                    [disableRipple]="true"
                    (click)="onSkipClick()">
                    Skip
                </button>
                <button
                    mat-flat-button
                    type="button"
                    color="accent"
                    [disableRipple]="true"
                    (click)="onFlagClick()">
                    Flag for team to review
                </button>
                <button
                    mat-flat-button
                    type="button"
                    color="primary"
                    [disableRipple]="true"
                    (click)="onTeachClick()">
                    <i class="ph-bold ph-graduation-cap icon-white icon-16" aria-hidden="true"></i>
                    Teach Gable
                </button>
            </div>
        </div>

        <!-- Send-feedback panel — non-lesson chip or non-super user. -->
        <div class="follow-up send-panel" *ngIf="showSendPanel">
            <label>Tell us a bit more <span class="optional-tag" *ngIf="selectedChip !== 'other'">(optional)</span></label>
            <textarea
                class="send-textarea"
                [(ngModel)]="detailText"
                [placeholder]="currentDetailPlaceholder"
                rows="3"></textarea>
            <div class="follow-up-actions follow-up-actions-right">
                <button
                    mat-flat-button
                    type="button"
                    color="accent"
                    class="ghost-btn"
                    [disableRipple]="true"
                    (click)="onSkipClick()">
                    Skip
                </button>
                <button
                    mat-flat-button
                    type="button"
                    color="primary"
                    [disableRipple]="true"
                    (click)="onSendClick()">
                    Send feedback
                </button>
            </div>
        </div>
    </div>
</div>
